import wiki from "refractor/wiki";
export default wiki;